<template>
  <v-app v-show="localeLoaded" :class="getBackground">
    <div class="sup_menu_wrapper invicta" v-if="!$vuetify.display.mobile && !isBookingStep">
      <div class="sup_menu d-flex flex-row">
        <div class="sup_menu_item" :class="item.selected ? 'selected' : ''" v-for="(item, index) in sup_menu_items" :key="index"><a :href="item.value" target="_blank">{{ item.title }}</a></div>
        <v-spacer/>
        <div v-if="selectedLocale != 'ru'" class="sup_menu_item">
          <a :href="blog_menu_item.value" target="_blank">{{ blog_menu_item.title }}</a>
        </div>
        <Select
          v-model="lang"
          class="selectfield--change-language"
          menu-cls="selectfield--change-language"
          :placeholder="$t('page.choose_language_label')"
          menu-placement="bottom-end"
          :border="true"
          :clear-icon="false"
          :options="langOptions"
        >
          <template #input="{ modelValue }">
            <img :src="worldIcon" height="20" /><span class="lang_label">{{ modelValue?.name }}</span>
          </template>
          <template #option="{ option }">{{ option.name }}</template>
        </Select>
      </div>
    </div>
    <div v-else-if="!isBookingStep" class="sup_menu_mobile_wrapper">
      <v-select
        class="sup_menu_select"
        :class="dialog || dialog.logged ? 'sup_menu_select_color' : ''"
        :items="sup_menu_items"
        v-model="selected_location"
      >
      <template v-slot:item="{item}">
        <div class="location_item pa-4 w-100"><a :href="item.value" target="_blank">{{ item.title }}</a></div>
      </template>
      </v-select>
    </div>
    <div class="toolbar-wrapper">
      <v-toolbar class="main_toolbar py-2 pr-2" :class="dialog ? 'dialog' : ''">
      <span>
        <a :href="`https://bank.invicta.pl${$t('bank_invicta_path.home')}`" target="_blank">
          <div v-if="!dialog" class="logo ml-4 ml-md-0"></div>
          <div v-else class="logo_white ml-4 ml-md-0"></div>
        </a>
      </span>
      <v-spacer
        v-if="$vuetify.display.mobile"
      ></v-spacer>
      <favourites-component 
        v-if="$vuetify.display.mobile && oidcUser?.roles.includes('ROLE_PATIENT') && !dialog && !isBookingStep"
        class="mr-10"/>
      <add-to-cart-icon-component
        v-if="$vuetify.display.mobile && oidcUser?.roles.includes('ROLE_PATIENT') && !dialog && !isBookingStep"
        class="mr-10"/>
      <div
        v-if="!isBookingStep"
        @click="$vuetify.display.mobile ? dialog = !dialog : dialog_logged = !dialog_logged"
        class="mr-4 order-last"
      >
        <div v-if="$vuetify.display.mobile">
          <v-icon v-if="!dialog" color="primary">mdi-menu</v-icon>
          <v-icon @click="dialog = false" v-else class="close-button pl-1 pt-0" size="24" color="white">mdi-close</v-icon>
        </div>
        <div v-if="!$vuetify.display.mobile && oidcUser" class="d-flex flex-row justify-center align center ">
          <v-icon class="mr-2" color="primary">mdi-account-circle-outline</v-icon><span class="account">{{ $t('user.my_account_btn') }}</span>
        </div>
      </div>
      <v-dialog
        v-model="dialog"
        :fullscreen="$vuetify.display.mobile"
        transition="no-transition"
        class="desktop_dialog menu_dialog"
        no-click-animation
      >
        <v-card
          class="rounded-0 menu_card"
          :class="{'menu_position': !$vuetify.display.mobile}"
        >
          <v-list flat class="pt-0 d-flex flex-column menu invicta" :class="dialog ? 'dialog' : ''">
            <div v-if="!oidcUser?.roles.includes('ROLE_PATIENT_COORDINATOR')">
              <v-list-item
                v-for="(item, i) in items"
                :key="i"
                class="item mt-0"
                :class="$vuetify.display.mobile ? 'dialog' : ''"
              >
                <div class="router_item router_item_mobile">
                  <a :href="item.to" target="_blank" @click="dialog = false"> {{ item.text }}</a>
                </div>
              </v-list-item>
            </div>

            <v-spacer v-if="$vuetify.display.mobile"></v-spacer>
            <v-list-item
              :key="i"
              class="item mt-0"
              :class="$vuetify.display.mobile ? 'dialog' : ''"
            >
              <div v-if="!oidcUser?.roles.includes('ROLE_PATIENT_COORDINATOR') && selectedLocale != 'ru'"
                class="router_item router_item_mobile">
                <a :href="blog_menu_item.value" target="_blank" @click="dialog = false"> {{ blog_menu_item.title }}</a>
              </div>
            </v-list-item>
            <Select
              v-model="lang"
              class="selectfield--change-language pa-2 pl-4 w-100"
              menu-cls="selectfield--change-language"
              :placeholder="$t('page.choose_language_label')"
              menu-placement="bottom-end"
              :border="true"
              :clear-icon="false"
              :options="langOptions"
            >
              <template #input="{ modelValue }">
                <img :src="worldIcon" height="20" /><span class="lang_label">{{ modelValue?.name }}</span>
              </template>
              <template #option="{ option }">{{ option.name }}</template>
            </Select>
            <v-list-item v-if="!oidcUser" class="mt-8">
              <v-btn class="wide signup_mobile_button menu_button"
                data-test="menu-mobile-signup-button"
                variant="outlined"
                height="48"
                @click="goToRegistration">
                {{ $t('user.register_btn') }}
              </v-btn>
            </v-list-item>
            <v-list-item v-if="!oidcUser" class="mt-2 mb-8 pb-14">
              <v-btn class="wide login_mobile_button menu_button mb-2"
                data-test="menu-mobile-login-button"
                height="48"
                @click="redirect"
                rounded>
                {{ $t('user.login_btn') }}
              </v-btn>
            </v-list-item>
            <v-divider class="divider my-8" v-if="oidcUser"></v-divider>
            <v-list-item class="header" :class="$vuetify.display.mobile ? 'mobile_header' : ''" v-if="oidcUser">{{ $t('user.account_header') }}</v-list-item>

            <v-list-item class="item" v-if="oidcUser" @click="dialog_logged=true">
              <div class="my-account router_item_mobile d-flex justify-space-between align-center">
                <div :class="$vuetify.display.mobile ? 'dialog' : 'primary'">{{ $t('user.my_account_btn') }}</div>
                <div class="mr-2">
                  <img :src="chevron_right_icon_white"/>
                </div>
              </div>
            </v-list-item>

            <v-divider class="divider mt-8 mb-8" v-if="oidcUser"></v-divider>
            
            <v-list-item class="item mb-8 pb-14" data-test="mobile-signout-item" v-if="oidcUser" @click="signOutOidcSilent">
              <span class=" d-flex align-center">
                <img :src="logout_icon_white" class="mr-4"/><span>{{ $t('user.logout_btn') }}</span>
              </span>
            </v-list-item>
            
          </v-list>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialog_logged"
        :fullscreen="$vuetify.display.mobile"
        :hide-overlay="true"
        transition="dialog-right-transition"
        class="desktop_dialog"
        :class="$vuetify.display.mobile ? 'menu_logged' : 'menu_logged_desktop'"
      >
        <v-card
          class="rounded-0"
          :class="{'menu_position': !$vuetify.display.mobile}"
        >
          <v-toolbar
            dark
            color="white"
            class="d-flex align-center"
              v-if="$vuetify.display.mobile"
          >
            <v-btn
              dark
              @click="dialog_logged = false"
              class="text-none"
              color="white"
            >
              <div class="d-flex align-center mt-1">
                <div class="mr-3">
                  <img :src="chevron_left_icon_white"/>
                </div>
                <div class="mb-1">{{ $t('page.go_back') }}</div>
              </div>
            </v-btn>
          </v-toolbar>
          <v-list flat class="pt-0 pb-0 d-flex flex-column menu" :class="dialog ? 'dialog' : ''">
            
            <v-list-item class="item mt-0" v-if="oidcUser && !$vuetify.display.mobile">
              <div class="router_item router_item_mobile d-flex flex-column align-center text-center py-4">
                <div class="bold mb-1">{{oidcUser.name}}</div>
                <div class="email">{{oidcUser.email}}</div>
              </div>
            </v-list-item>

            <v-list-item v-if="$vuetify.display.mobile" class="pt-7 header mb-4" :class="$vuetify.display.mobile ? 'mobile_header' : ''">{{ $t('user.my_account_header') }}</v-list-item>

            <v-divider class="divider" v-if="oidcUser && !$vuetify.display.mobile"></v-divider>
            
            <div v-if="oidcUser?.roles.includes('ROLE_PATIENT')">
              <v-list-item
                v-for="(item, i) in $vuetify.display.mobile ? account_items : account_items_desktop"
                :key="i"
                class="item mt-0"
              >
                <span class="router_item router_item_mobile d-flex align-center"
                  @click="dialog_logged = false; dialog = false;">
                  <img class="mr-4 ml-1" :src="item.icon" width="21"/><router-link :to="item.to" @click="dialog = false" class="flex-grow-1" :class="dialog_logged && $vuetify.display.mobile ? '' : 'primary'"> {{ item.text }}</router-link>
                </span>
              </v-list-item>
            </div>

            <div v-if="oidcUser?.roles.includes('ROLE_PATIENT_COORDINATOR')">
              <v-list-item
                v-for="(item, i) in $vuetify.display.mobile ? coordinator_account_items : coordinator_account_items_desktop"
                :key="i"
                class="item mt-0"
              >
              <span class="router_item router_item_mobile d-flex align-center"
                  @click="dialog_logged = false; dialog = false;">
                  <img class="mr-4 ml-1" :src="item.icon" width="19"/><router-link :to="item.to" @click="dialog = false" class="flex-grow-1" :class="dialog_logged && $vuetify.display.mobile ? '' : 'primary'"> {{ item.text }}</router-link>
                </span>
              </v-list-item>
            </div>
            
            <v-divider class="divider" v-if="oidcUser && !$vuetify.display.mobile"></v-divider>
            
            <v-list-item class="item mt-0" data-test="signout-item" v-if="oidcUser && !$vuetify.display.mobile" @click="signOutOidcSilent">
              <span class="router_item router_item_mobile d-flex align-center"
                @click="dialog_logged = false; dialog = false;">
                <img class="mr-4 ml-1 my-3" :src="logout_icon"/><span :class="!$vuetify.display.mobile ? 'primary' : ''">{{ $t('user.logout_btn') }}</span>
              </span>
            </v-list-item>
          </v-list>
          
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialog_logged_out"
        :fullscreen="$vuetify.display.mobile"
        :width="$vuetify.display.mobile ? '100%' : '588px'"
        class="logged-out-modal"
      >
        <v-card class="px-4 d-flex flex-column" :width="$vuetify.display.mobile ? '100%' : '588px'">
          <div class="header d-flex flex-row justify-space-between align-center">
            <div class="modal-header mt-4 mb-5">{{ $t('user.logout_modal_header') }}</div>
            <v-btn flat icon color="transparent" size="x-small" class="modal-close" @click="dialog_logged_out = false">
              <v-icon color="primary" size="24" icon="mdi-close"></v-icon>
            </v-btn>
          </div>
          <v-spacer v-if="$vuetify.display.mobile"></v-spacer>
          <div class="modal-buttons text-right">
            <v-btn
              height="40"
              :width="$vuetify.display.mobile ? '100%' : 'auto'"
              color="primary"
              flat
              rounded
              class="mb-4 mr-md-4 ml-md-0 px-6"
              @click="redirect()"
            >{{ $t('user.re_login_btn') }}</v-btn>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog
        v-if="oidcUser"
        v-model="showMzDialog"
        :fullscreen="$vuetify.display.mobile"
        :width="$vuetify.display.mobile ? '100%' : '620px'"
        class="mz-modal"
      >
        <v-card class="px-4 px-md-8 pb-4 pb-md-8 d-flex flex-column" :width="$vuetify.display.mobile ? '100%' : '620px'">
          <div class="text-right">
            <v-btn 
              flat
              icon
              size="x-small"
              color="transparent"
              class="modal-close my-4 mr-0 mr-md-n4"
              @click="setMzDialogAsShown()"
            >
              <v-icon color="primary" size="24" icon="mdi-close"></v-icon>
            </v-btn>
          </div>
          <div class="modal-header-logo px-6 py-2 text-center">
            <img :src="mz_program_logo"/>
          </div>
          <div class="modal-title mt-8 px-md-2 text-md-center text-left">
            {{ $t('mz.modal_title') }}
          </div>
          <div
            class="modal-text mt-8 pl-md-2 text-left"
            v-if="getFileMzGrant('mtSemen') && !getFileMzGrant('mtCell')"
            v-html="$t('mz.modal_semen_text', {locale: $t(getFileMzGrant('mtSemen')['treatment_location_name'])})"
            ></div>
          <div
            class="modal-text mt-8 pl-md-2 text-left"
            v-if="getFileMzGrant('mtCell')"
            v-html="$t('mz.modal_cell_text', {locale: $t(getFileMzGrant('mtCell')['treatment_location_name'])})"
            ></div>
          <v-spacer v-if="$vuetify.display.mobile"></v-spacer>
          <div class="modal-buttons text-center mt-8 d-flex flex-column align-center">
            <v-btn
              v-if="getFileMzGrant('mtCell')"
              height="40"
              :width="$vuetify.display.mobile ? '100%' : 'auto'"
              flat
              rounded
              class="proceed_button mb-2"
              @click="setMaterialTypeAndLocationAndGoToResults(
                'mtCell',
                getFileMzGrant('mtCell')['treatment_location_name']
              )"
            >{{ $t('mz.proceed_btn') }}</v-btn>

            <v-btn
              v-if="getFileMzGrant('mtSemen') && !getFileMzGrant('mtCell')"
              height="40"
              :width="$vuetify.display.mobile ? '100%' : 'auto'"
              flat
              rounded
              class="proceed_button mb-2"
              @click="setMaterialTypeAndLocationAndGoToResults(
                'mtSemen',
                getFileMzGrant('mtSemen')['treatment_location_name']
              )"
            >{{ $t('mz.proceed_btn') }}</v-btn>
          </div>
        </v-card>
      </v-dialog>

      <v-toolbar-items  v-if="!$vuetify.display.mobile && !isBookingStep" class="d-flex align-center justify-end flex-grow-1">
        <v-spacer></v-spacer>

        <favourites-component v-if="oidcUser?.roles.includes('ROLE_PATIENT')" class="mr-10"/>
        <add-to-cart-icon-component
          v-if="oidcUser?.roles.includes('ROLE_PATIENT')"
          class="mr-10"/>
        <v-btn
          class="mr-4 px-6 menu_button"
          data-test="signup-button"
          v-if="!oidcUser"
          variant="outlined"
          @click="goToRegistration"
          rounded
          color="primary"
          height="40"
        >
          {{ $t('user.register_btn') }}
        </v-btn>
        <v-btn
          class="px-6 login_button menu_button"
          data-test="login-button"
          v-if="!oidcUser"
          @click="redirect"
          rounded
          height="40"
          flat
        >
          {{ $t('user.login_btn') }}
        </v-btn>
      </v-toolbar-items>
      </v-toolbar>
    </div>
    <div class="sub_menu" v-if="!$vuetify.display.mobile && !isBookingStep">
      <div class="sub_menu_wrapper mt-1">
        <div v-if="!oidcUser?.roles.includes('ROLE_PATIENT_COORDINATOR')" class="d-flex flex-row ml-n4">
          <span class="nav-link router_item sub_menu_item px-4 py-1" v-for="(item, index) in items" :key="index">
            <a :href="item.to" target="_blank">{{ item.text }}</a>
          </span>
        </div>
        <div v-else class="d-flex flex-row ml-n4">
          <span class="nav-link router_item sub_menu_item px-4 py-1" v-for="(item, index) in coordinator_account_items" :key="index">
            <router-link :to="item.to">{{ item.text }}</router-link>
          </span>
        </div>
      </div>
    </div>
    <div class="sub_menu breadcrumb_menu" v-if="!$vuetify.display.mobile && !isBookingStep && !oidcUser?.roles.includes('ROLE_PATIENT_COORDINATOR')">
      <div class="sub_menu_wrapper mt-1 text-left">
        <breadcrumb-component :mode="'manual'" :route="getRoute"/>
      </div>
    </div>

    <reservation-steps-component v-if="isBookingStep && checkedCartItemIds.length"/>

    <div :class="['view', oidcUser?.roles.includes('ROLE_PATIENT_COORDINATOR') ? 'coordinator-view' : '']">
      <alert-message ref="alertMessageRef" class="my-6"/>
      <router-view  v-if="localeLoaded"
        @openMyAccount="dialog = true; dialog_logged = true;"/>
    </div>
    <div
      class="compare_list_wrapper py-2 d-flex justify-center"
      v-if="showCompareList && !isBookingStep"
    >
      <div class="compare_list d-flex flex-column flex-md-row align-md-center align-start ma-4 ma-md-0 mr-md-4">
        <div v-if="!$vuetify.display.mobile" class="clear_compare_list" @click="$store.dispatch('compareModule/clearCompareList',getContext)">
          {{ $t('compare_list.clear_all') }}
        </div>
        <v-spacer></v-spacer>
        <div class="compare_list_label text-left mb-md-0 mb-2">{{ $t('compare_list.label') }}</div>
        <div class="d-flex mr-md-12 mb-md-0 mb-8">
          <div
            v-for="(material, index) in getCompareListByMaterialType(getContext)"
            :key="index"
            class="compare_list_element ml-4"
            @click="$router.push({
                name: 'donorDetails',
                params: {
                    materialType: getContext == 'mtCell' ? $t('donor.mtCell.nom') : $t('donor.mtSemen.nom'),
                    id: material.pk
                }
            })"
          >
            {{material.id}}
          </div>
        </div>
        <v-btn
          v-if="!$vuetify.display.mobile"
          color="primary"
          variant="flat"
          rounded
          @click="$router.push({name: 'compareView', query: {ids: getCompareListByMaterialType(getContext).map(e => e.pk)} })"
          class="mb-md-0 mb-4 compare-button"
        >
          {{ $t('compare_list.show_btn') }}
        </v-btn>

        <v-btn
          v-else
          color="primary"
          variant="flat"
          rounded
          @click="$router.push({name: 'compareView', query: {ids: getCompareListByMaterialType(getContext).map(e => e.pk)} })"
          block
          height="48"
          class="mb-md-0 mb-4"
        >
          {{ $t('compare_list.show_btn') }}
        </v-btn>

        <v-btn
          v-if="$vuetify.display.mobile"
          color="white"
          text="primary"
          variant="flat"
          rounded
          block
          height="48"
          @click="$store.dispatch('compareModule/clearCompareList',getContext)"
          class="clear-button mb-4"
        >
          {{ $t('compare_list.clear_btn') }}
        </v-btn>
      </div>
    </div>
    <div class="check_different_donor_info mb-16" v-if="$route.name === 'confirmationView'">
      <div class="check_different_donor_info_wrapper text-left">
        <v-row class="my-6 mx-2">
          <v-col cols="12" md="8" offset-md="2">
            <div class="header">{{$t('confirmation.choose_different_donor_header')}}</div>
            <div class="label py-6 py-md-4">{{$t('confirmation.choose_different_donor_text')}}</div>
            <v-btn 
              :class="['px-6', $vuetify.display.mobile ? 'w-100' : '']"
              plain elevation="0"
              color="primary" 
              height="40"
              rounded 
              @click="goToSearchDonorByPhenotype">
                {{$t('confirmation.check_proposals_btn')}}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <div v-if="$vuetify.display.mobile && ['bookingComponent','dashboardView'].includes($route.name)"></div>
    <div v-else class="footer d-flex justify-center align-center"> 
      <footer-component/>
    </div>
  </v-app>
</template>

<script>
import axios from 'axios'
import { useStore, mapGetters } from 'vuex'
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { merge, loadDonorDictionaryMessages, availableLocales } from './i18n'
import { useRoute, useRouter } from 'vue-router'
import FavouritesComponent from './components/FavouritesComponent.vue'
import AddToCartIconComponent from './components/AddToCartIconComponent.vue'
import AlertMessage from './components/AlertMessageComponent.vue'
import FooterComponent from './components/FooterComponent.vue'
import BreadcrumbComponent from './components/BreadcrumbComponent.vue'
import ReservationStepsComponent from './components/ReservationStepsComponent.vue'
import { Select } from 'design-system-ui-components'

export default {
  data: () => {
    return {
      dialog: false,
      dialog_logged: false,
      dialog_logged_out: false,
      expireTokenChecker: null,
      selectedItem: 1,
      store: useStore(),
      chevron_right_icon: require('@/assets/icons/chevron-right.svg'),
      chevron_right_icon_white: require('@/assets/icons/chevron-right-white.svg'),
      chevron_left_icon: require('@/assets/icons/chevron-left.svg'),
      chevron_left_icon_white: require('@/assets/icons/chevron-left-white.svg'),
      logout_icon: require('@/assets/icons/logout.svg'),
      logout_icon_white: require('@/assets/icons/logout-white.svg'),
      mz_program_logo: require('@/assets/img/mz_program_logo.png'),
      location_open: false
    }
  },
  components: {
    FavouritesComponent,
    AddToCartIconComponent,
    AlertMessage,
    FooterComponent,
    BreadcrumbComponent,
    ReservationStepsComponent,
    Select
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const oidcUser = computed(() => store.getters['oidcStore/oidcUser'])
    const localeLoaded = ref(false)
    const {t, locale, setLocaleMessage} = useI18n({useScope: 'global'})
    const aLocales = ref(availableLocales)
    const selectedLocale = ref(locale.value)
    const loadedLocales = []
    const lang = ref({ name: availableLocales[locale.value].nativeName, value: locale.value })
    const langOptions = Object.entries(availableLocales).map((e)=> {
      return { name: e[1].nativeName, value: e[0] }
    });
    const changeLangByUserInfoLocale = false

    const loadMessages = async (locale) => {
      const localMessages = await import(`./locales/${locale}`)
      const donorDictionaryMessages = await loadDonorDictionaryMessages(locale)
      loadedLocales.push(locale)

      setLocaleMessage(locale, merge({[locale]:localMessages.default}, donorDictionaryMessages)[locale])
    }

    const onChangeLocale = async (l = null) => {
      if (l && aLocales.value[l]) {
        locale.value = l
      } else {
        locale.value = selectedLocale.value
      }
      axios.defaults.headers.common['Accept-Language'] = locale.value

      document.title = t('seo.title')
      document.getElementsByTagName('meta')["description"].content = t('seo.description')

      if (!loadedLocales.includes(selectedLocale.value)) {
        await loadMessages(selectedLocale.value)
      }

      if (oidcUser.value) {
        axios.put(`/api/language`, {
          language: locale.value
        })
      }
    }

    if ('BroadcastChannel' in self) {
      const channel = new BroadcastChannel('logoutByOtherClient')
      channel.onmessage = (e) => {
        if (e.data.logout && route.name != 'logout') {
          store.dispatch('signOutClear')
          router.push({name: "search"})
        }
      }
    }

    const worldIcon = computed({
      get: () => { return require('./assets/icons/world.svg');}
    })

    return {
      localeLoaded,
      aLocales,
      selectedLocale,
      onChangeLocale,
      loadMessages,
      loadedLocales,
      oidcUser: oidcUser,
      checkedCartItemIds: computed(() => store.getters['reservationModule/getChecked']),
      accessTokenExpiresAt: computed(() => store.state.oidcStore.expires_at),
      _locale: computed(() => route.query._locale),
      lang,
      langOptions,
      changeLangByUserInfoLocale,
      hasAnyFileMzGrant: computed(() => store.getters['fileMTModule/hasAnyFileMzGrant']),
      isShownMzDialog: computed(() => store.getters['fileMTModule/isShownMzDialog']),
      getFileMzGrant: (materialType) => store.getters["fileMTModule/getFileMzGrantByMaterialType"](materialType),
      worldIcon
    }
  },
  computed: {
    items() {
      return [
        { text: this.$t('page.be_a_parent_label'), to: `https://bank.invicta.pl${ this.$t('bank_invicta_path.planning_parenthood') }` },
        { text: this.$t('page.be_a_cell_donor_label'), to: `https://bank.invicta.pl${ this.$t('bank_invicta_path.become_egg_donor') }` },
        { text: this.$t('page.be_a_semen_donor_label'), to: `https://bank.invicta.pl${ this.$t('bank_invicta_path.become_sperm_donor') }` },
        { text: this.$t('page.contact_label'), to: `https://bank.invicta.pl${ this.$t('bank_invicta_path.contact') }` }
      
      ]
    },
    account_items() {
      return [
        { text: this.$t('page.personal_data_name'), to: '/personal-details', icon: require('@/assets/icons/widget-white.svg') },
        { text: this.$t('page.favorite_profiles_name'), to: '/favourites', icon: require('@/assets/icons/heart-white.svg') },
        { text: this.$t('page.phenotype_name'), to: '/phenotype', icon: require('@/assets/icons/phenotype-white.svg') },
        { text: this.$t('page.reservations_name'), to: '/reservations', icon: require('@/assets/icons/booking-white.svg') },
        { text: this.$t('page.deposits_name'), to: '/deposits', icon: require('@/assets/icons/deposits-white.svg') },
        { text: this.$t('page.legal_information_name'), to: '/legal-information', icon: require('@/assets/icons/legal-white.svg') }
      ]
    },
    account_items_desktop() {
      return [
        { text: this.$t('page.personal_data_name'), to: '/dashboard?selected=personal-details', icon: require('@/assets/icons/widget.svg') },
        { text: this.$t('page.favorite_profiles_name'), to: '/dashboard?selected=favourites', icon: require('@/assets/icons/heart.svg') },
        { text: this.$t('page.phenotype_name'), to: '/dashboard?selected=phenotype', icon: require('@/assets/icons/phenotype.svg') },
        { text: this.$t('page.reservations_name'), to: '/dashboard?selected=reservations', icon: require('@/assets/icons/booking.svg') },
        { text: this.$t('page.deposits_name'), to: '/dashboard?selected=deposits', icon: require('@/assets/icons/deposits.svg') },
        { text: this.$t('page.legal_information_name'), to: '/dashboard?selected=legal-information', icon: require('@/assets/icons/legal.svg') }
      ]
    },
    coordinator_account_items() {
      return [
        { text: this.$t('page.reservations_name'), to: { name: 'coordinatorBookingComponent' }, icon: require('@/assets/icons/booking-white.svg') },
        { text: this.$t('page.grants_name'), to: { name: 'coordinatorGrantComponent' }, icon: require('@/assets/icons/badge-white.svg') },
        { text: this.$t('page.dashboard_coordinator_name'), to: { name: 'dashboardCoordinatorView' }, icon: require('@/assets/icons/widget-white.svg') }
      ]
    },
    coordinator_account_items_desktop() {
      return [
        { text: this.$t('page.reservations_name'), to: { name: 'coordinatorBookingComponent' }, icon: require('@/assets/icons/booking.svg') },
        { text: this.$t('page.grants_name'), to: { name: 'coordinatorGrantComponent' }, icon: require('@/assets/icons/badge.svg') },
        { text: this.$t('page.dashboard_coordinator_name'), to: { name: 'dashboardCoordinatorView' }, icon: require('@/assets/icons/widget.svg') }
      ]
    },
    showCompareList() {
      return this.getCompareListByMaterialType(this.getContext).length &&
        (this.$route.name == 'resultsView'  ||
        this.$route.name == 'donorDetails' ||
        this.$route.name == 'FavouritesView' ||
         (this.$route.name == 'dashboardView' && this.$route.query.selected=='favourites'))
    },
    showMzDialog() {
      return this.hasAnyFileMzGrant && !this.isShownMzDialog;
    },
    getBackground() {
      if (this.$route.meta.role === 'ROLE_PATIENT_COORDINATOR') {
        return 'dashboard-page';
      }

      switch(this.$route.name) {
        case 'search': return 'main-page';
        case 'resultsView': return 'main-page';
        case 'completePhenotypeView': return 'main-page';
        case 'calcView': return 'white-page';
        case 'calcDonorView': return 'white-page';
        case 'reservationPhenotypeView': return 'white-page';
        case 'confirmationView': return 'white-page';
        case 'reservationView': return 'white-page';
        default: return 'sub-page';
      }
    },
    isBookingStep() {
      return ['reservationPhenotypeView','confirmationView','reservationView'].includes(this.$route.name) ? true : false
    },
    blog_menu_item() {
      return {
        title: this.$t("page.invicta_blog_name"),
        selected: false,
        value: `https://bank.invicta.pl${ this.$t('bank_invicta_path.blog') }`
      }
    },
    sup_menu_items() {
      return [
        {
          title: this.$t("page.invicta_group_name"),
          selected: false,
          value: 'http://invicta.pl'
        },
        {
          title: this.$t("page.invicta_clinic_name"),
          selected: false,
          value: 'https://www.klinikainvicta.pl'
        },
        {
          title: this.$t("page.invicta_laboratories_name"),
          selected: false,
          value: 'https://laboratoria.invicta.pl/'
        },
        {
          title: this.$t("page.invicta_bank_name"),
          selected: true,
          value: `https://bank.invicta.pl${ this.$t('bank_invicta_path.home') }`
        },
        {
          title: this.$t("page.invicta_anti_aging_name"),
          selected: false,
          value: 'https://www.klinikaantiaging.pl'
        },
        {
          title: this.$t("page.invicta_research_and_development_name"),
          selected: false,
          value: 'http://cbr.invicta.pl'
        },
      ]
    },

    selected_location() {
      return {
        title: 'Bank INVICTA',
        selected: true,
        value: `https://bank.invicta.pl${ this.$t('bank_invicta_path.home') }`
      }
    },
    ...mapGetters('breadcrumbModule', ['getRoute']),
    ...mapGetters('reservationModule', ['getReservation']),
    ...mapGetters('compareModule', ['getCompareList','getCompareListByMaterialType','getContext'])
  },
  methods: {
    locationSelected(e) {
      //TODO: prevent going to page we are already at
      window.open(e, '_blank');
    },
    redirect() {
      this.dialog = false;
      this.dialog_logged_out = false;

      if (this.$keycloak.authenticated) {
        this.authenticateOidc()
      } else {
        this.$router.push({
            name: 'redirect',
            params: {
                mode: 'login',
                pathname: location.pathname
            }
        })
      }
    },
    authenticateOidc() {
      this.store.dispatch('oidcStore/authenticateOidc', this.$route.params.pathname)
    },
    signOutOidcSilent() {
      this.store.dispatch('oidcStore/signOutOidcSilent').then(
        () => {
          this.store.dispatch('signOutClear');
          this.dialog = false;
          this.$router.push({name: "search"});
        }
      )
    },
    goToRegistration() {
      this.dialog = false;
      if (this.$keycloak.realm != process.env.VUE_APP_AUTH_REALM_NAME) {
        this.$keycloak.init(this.$keycloakInitOptions).then(() => {
          this.redirectToRegisterUrl()
        })
      } else {
        this.redirectToRegisterUrl()
      }
    },
    redirectToRegisterUrl() {
      this.$router.push({
          name: 'redirect',
          params: {
              mode: 'simple',
              pathname: location.pathname,
              url: this.$keycloak.createRegisterUrl({locale: this.$i18n.locale})
          }
      })
    },
    goToSearchDonorByPhenotype() {
      this.store.dispatch('resultsModule/setSearchForSimilar', true).then(
        () => {
          this.$router.push({name: 'resultsView'})
          window.scrollTo({ top: 0, behavior: 'smooth'})
        }
      )
    },
    setMaterialTypeAndLocationAndGoToResults(materialType, locationName) {
      this.store.dispatch('filtersModule/setMaterialType', materialType).then(
        () => {
          let filters = [{
            type: "terms",
            field: "material.location.city",
            value: [
              {
                key: locationName,
                doc_count: 0
              }
            ]
          }]
          this.store.dispatch('filtersModule/setFilters', filters).then(
            () => {
              if (this.$route.name == 'resultsView') {
                this.setMzDialogAsShown()
                window.location.reload()
              }
              this.$router.push({name: 'resultsView'})
              window.scrollTo({ top: 0, behavior: 'smooth'})
              this.setMzDialogAsShown()
            }
          )
        }
      )


    },
    setMzDialogAsShown() {
      this.store.dispatch('fileMTModule/setShownMzDialog', true);
    },
    track() {
      this.$gtag.customMap({ 
        'dimension1': 'donor_product_key',
        'dimension2': 'donor_material_type',
        'dimension3': 'donor_event_value'
      })
    }
  },
  async beforeMount() {
    await this.loadMessages(this.selectedLocale).then(() => {
      this.localeLoaded = true
      document.title = this.$t('seo.title')
      document.getElementsByTagName('meta')["description"].content = this.$t('seo.description')
    })
  },
  created() {
    this.$watch('getReservation', (reservation) => {
      if(reservation) {
        this.$router.push({name: 'reservationView', params: {origin: 'resultsView'}});
      }
    });
    this.$watch('oidcUser', (oidcUser) => {
      if (oidcUser) {
        if (!oidcUser.roles) {
          this.store.dispatch('oidcStore/removeOidcUser')
        }
        if(oidcUser.locale != this.$i18n.locale && this.aLocales[oidcUser.locale] && !this._locale) {
          this.changeLangByUserInfoLocale = true
          this.selectedLocale = oidcUser.locale
          this.onChangeLocale()
          this.changeLangByUserInfoLocale = false
        }
      }
    })
    this.$watch('_locale', (l) => {
      if (l && this.aLocales[l]) {
        this.selectedLocale = l
        this.onChangeLocale()
      }
    });
    this.$watch('lang', (lang) => {
      this.selectedLocale = lang.value
      this.onChangeLocale(lang.value)

      if (lang && !this.changeLangByUserInfoLocale && this.aLocales[lang.value]) {
        let route = this.$router.resolve({
          name: this.$route.name,
          params: this.$route.params,
          query: {
            ...this.$route.query,
            _locale: lang.value,
          }
        })
        window.location.assign(route.href)
      }
    });
  },
  mounted() {
    const script = document.createElement("script")
    script.src=`https://js-eu1.hs-scripts.com/${process.env.VUE_APP_HUB_SPOT_ID}.js`
    document.body.appendChild(script)

    this.$root.$alertMessageRef = this.$refs.alertMessageRef
    
    let urlParams = new URLSearchParams(window.location.search);
    if (!this.oidcUser && !['oidcCallback','oidcCallbackError'].includes(this.$route.name) && !urlParams.has('code')) {
      this.$keycloak.init(this.$keycloakInitOptions).then((authenticated) => {
        if (authenticated) {
          this.authenticateOidc()
        }
      }).catch(err => {
        console.error(err)
      })
    }

    this.expireTokenChecker = setInterval(() => {
      if (this.oidcUser) {
        let refreshTokenExiredAt = this.accessTokenExpiresAt+(parseInt(process.env.VUE_APP_REFRESH_AND_ACCESS_TOKEN_LIFETIME_DIFF)*1000)
        if (Date.now() > refreshTokenExiredAt) {
          this.store.dispatch('oidcStore/authenticateOidcSilent')
            .then()
            .catch((err) => {
              console.error(err)
              this.dialog_logged_out = true
              this.signOutOidcSilent()
            })
          console.log('Refresh token did expire')
        }
      }
    }, 3 * 1000);

    this.track()
  },
  unmounted() {
    clearInterval(this.expireTokenChecker)
  }
}
</script>

<style lang="scss">
@import "../node_modules/design-system-ui-components/dist/all.min.css";
  .v-divider {
    border-top: 1px solid lightgray !important;
  }
  .invicta .selectfield .selectfield--selection svg {
    color: white;
  }
  .invicta .selectfield--change-language {
    margin-top: 10px;
    color: white;
    .lang_label {
      font-size: 12px;
      line-height: 20px;
    }
    .selectfield--selection {
      width: 100% !important;
    }
  }
  .invicta .tooltip--container {
    width: auto !important;
    .tooltip--bubble {
      min-width: 250px;
    }
  }

  .sub_menu {
    width: 100vw;
    background: white;
    height: 52px;
    .sub_menu_wrapper {
      max-width: 1200px;
      margin: 0 auto;
      .sub_menu_item {
        &:hover {
          background: $ds-link-hover;
          border-radius: 4px;
        }
      }
    }
    &.breadcrumb_menu {
      background: transparent;
    }
  }
  // reset css
  body,
  html {
    margin: 0;
    padding: 0;
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: $ds-primary;
  }
  a {
    color: $ds-primary;
    text-decoration: none;
  }
  p {
    @include nsb-font-container;
  }

  h3 {
    margin: 30px 0 20px 0;
  }

  input {
    @include nsb-font-input;
  }
  input::placeholder {
    color: $ds-primary;
    opacity: 0.7;
  }

  iframe#sign-out-iframe {
    display: none;
    visibility: hidden;
  }

  .label {
    @include nsb-font-container;
    font-size: 14px;
    line-height: 21px;
  }

  .v-btn {
    @include nsb-font-button-semibold;
    .v-btn__content {
      white-space: normal;
    }
  }
  .v-card--disabled {
    background-color: $nsb-disabled !important;
    .text {
      color: $nsb-disabled-text;
      i {
        background-color: $nsb-disabled-text;
      }
    }
  }
  .border-primary {
    border-color: $ds-primary !important;
  }
  .logo {
    width: 132px;
    height: 32px;
    background: url('./assets/svg/Invicta_bank_plodnosci.svg');
    background-repeat: no-repeat;
    background-size: contain;
  }
  .logo_white {
    width: 132px;
    height: 32px;
    background: url('./assets/svg/Invicta_bank_plodnosci_white.svg');
    background-repeat: no-repeat;
    background-size: contain;
  }
  .v-toolbar {
    background-color: $ds-white !important;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    -webkit-padding-end: 0px;
    padding-inline-end: 0px;
  }
  .dialog {
      color: white;
      background-color: $ds-secondary !important;
  }
  .toolbar-wrapper {
    background: $ds-white;
    z-index: 10;
    width: 100vw;
  }
  .v-alert {
    .v-alert__content {
      @include nsb-font-container;
      font-size: 14px;
      color: $ds-primary;
      line-height: 21px;
      margin: auto;
      margin-left: 0px;
    }

    .v-alert__prepend {
      font-size: 14px;
      color: $ds-primary;
      align-self: center;
      margin-top: 12px;
    }
  }
  .nav-link {
    display: flex;
    align-items: center;
    a {
      @include nsb-font-container;
      color: $ds-primary !important;
      font-size: 14px;
      line-height: 21px;
      color: rgba(51, 51, 51, 1) // marked as "old/mockup color 5"
    }
    .v-icon {
      display: inline;
      margin-right: 16px;
      margin-bottom: 3px;
    }
  }
  .wide {
    width: 100%;
  }
  .menu {
    min-height: calc(100% - 60px);
  }
  .header {
    @include nsb-font-container-medium;
    font-size: 14px;
    line-height: 21px;
    font-weight: 500;
    &.mobile_header {
      @include nsb-gentium-bold;
      color: white !important;
      font-size: 18px;
      line-height: 24px;
    }
  }
  .item  {
    @include nsb-select-option;
    font-size: 14px;
    line-height: 21px;
    color: white !important;
    font-weight: 400;
    .primary {
      color: $ds-primary !important;
    }
    &:hover {
      background-color: rgba(0,0,0,0.05);
    }
  }
  .divider  {
    border-top-color: $nsb-color-3 !important;
  }
  .my-account {
    width: 100%;
  }
  .login_mobile_button {
    background-color: $ds-primary !important;
  }
  .login_button {
    background-color: $ds-primary !important;
    color: $ds-white !important;
    margin-right: -16px;
  }
  .proceed_button {
    background-color: $ds-primary !important;
    color: $ds-white !important;
  }
  .menu_button {
    border-radius: 20px !important;
  }
  .signup_mobile_button,
  .login_mobile_button {
    @include nsb-font-button-medium;
    font-size: 14px !important;
    line-height: 21px !important;
    font-weight: 500 !important;
    border-radius: 24px !important;
  }
  .signup_mobile_button {
    color: white !important;
  }
  .login_mobile_button {
    color: $ds-primary !important;
    background-color: white !important;

  }
  .router_item_mobile {
    width: 100%;
    color: $ds-primary;
    .router-link-active {
      width: 100%;
      display: inline-block;
    }
    a {
      color: white !important;
    }
  }
  .desktop_dialog {
    .v-overlay__scrim {
      background-color: rgba(0,0,0,0) !important;
    }
    .v-toolbar__content {
      background: $ds-secondary;
    }
    &.menu_dialog {
      margin-top: 120px;
      height: calc(100vh - 60px);
    }
    &.menu_logged {
      margin-top: 120px;
      height: calc(100vh - 60px);
    }
    &.menu_logged_desktop {
      margin-top: 80px;
    }
  }
  .menu {
    box-shadow: none !important;
  }
  .bold {
    @include nsb-font-header-bold;
    font-size: 14px;
    line-height: 21px;
    color: $ds-primary;
  }
  .email {
    @include nsb-font-container;
    font-size: 12px;
    line-height: 18px;
    color: $ds-primary;
  }
  .account {
    @include nsb-font-container;
    font-size: 12px;
    line-height: 24px;
    cursor: pointer;
  }

  @keyframes example {
    from {background-color: $ds-primary;}
    to {background-color: white;}
  }
  .compare_list_wrapper {
    animation-name: example;
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
    animation-timing-function: ease-in;

    color: $ds-primary;
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100vw;
    height: auto;
    background: white;
    z-index: 100;
    box-shadow: 0px -5px 10px rgba(0,0,0,0.3) !important;
    .compare_list {
      width: 1224px;
      .compare_list_element {
        cursor: pointer;
        @include nsb-font-container;
        font-size: 14px;
        line-height: 21px;
        color: $ds-primary;
        border-radius: 12px;
        background-color: $ds-primary-9;
        display: inline-block;
        padding: 1.5px 12px;
      }
    }
    .compare_list_label {
      @include nsb-font-container-medium;
      font-size: 16px;
    }
    .clear_compare_list {
      @include nsb-font-container;
      font-size: 12px;
      cursor: pointer;
      color: $ds-primary;
      text-decoration: underline;
    }
  }

  .check_different_donor_info {
    background: $ds-secondary-300;
    width: 100%;
    .check_different_donor_info_wrapper {
      max-width: 1200px;
      width: 100%;
      margin: 0 auto;
      .header {
        @include nsb-font-main-header;
        font-size: 23px !important;
        line-height: 34px;
      }
    }
  }

  .footer {
    background: $ds-secondary;
    color: white;
    bottom: 0px;
    width: 100%;
    z-index: 4;
  }

  .view {
    min-height: calc(100vh - 50px);
  }

  .logged-out-modal {
    .modal {
      &-header {
        @include nsb-font-main-header;
        font-size: 23px !important;
      }
      &-buttons {
        @include nsb-font-button;
        line-height: 21px !important;
      }
    }
  }
  .mz-modal {
    .modal {
      &-header-logo {
        border-radius: 4px;
      }
      &-title {
        @include nsb-font-main-header;
        font-size: 21px !important;
      }
      &-text {
        @include nsb-font-container;
        font-size: 14px;
        font-weight: 400;
        line-height: normal;
        ul {
          list-style-position: inside;
          list-style-type: "\2022 \00A0 \00A0";
          li {
            margin-left: 8px;
          }
        }
      }
      &-buttons {
        @include nsb-font-button;
        line-height: 21px !important;
      }
    }
  }
  .sup_menu_mobile_wrapper {
    height: 56px;
    position: relative;
    width: 100vw;
    .select-icon {
      position: absolute;
      color: $ds-primary;
      top: 16px;
      right: 24px;
      pointer-events: none;
    }
    .sup_menu_select {
      border: none;
      box-shadow: none;
      background: white;
      .dropdown-toggle {
        border: none !important;
        background: white;
      }
      .v-field__overlay {
        background: white;
      }
      .v-field__input {
        padding: 16px;
        background: white;
      }
      .v-field__append-inner {
        background: white;
      }
      .v-menu {
        width: 20px;
        background: white;
      }
      .location_item {
        padding: 16px;
        background: white;
      }
    }
  }
  .sup_menu_wrapper {
    width: 100vw;
    background: $ds-secondary;
    height: 40px;
    .sup_menu {
      width: 1200px;
      margin: auto;
      height: 100%;
      .sup_menu_item {
        outline: none;
        @include nsb-font-header;
        font-size: 12px;
        line-height: 20px;
        height: 40px;
        color: white;
        padding: 0 16px;
        a {
          color: inherit;
          display: block;
          line-height: 40px;
        }
        &.selected {
          @include nsb-font-header-bold;
          font-size: 12px;
          line-height: 20px;
          background: white;
          color: $ds-primary;
        }
        &:hover:not(.selected) {
          background: $ds-link-hover-16;
        }
      }
    }
  }
  .dashboard-page {
    .v-application__wrap {
      z-index: 3;
      background: white;
    }
  }
  .main-page {
    .v-application__wrap {
      z-index: 3;
      background: $ds-secondary-300;
      // background: #FFFDF0;
      // background-image: url(./assets/img/pacjenci-bank-invicta-min-5.jpg);
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center 136px;
    }
    background: transparent;
  }

  @media (min-width: 1200px) {
    .view.coordinator-view {
      width: 1200px !important;
    }
  }
  @media (min-width: 960px) {
    .main-page {
      .v-application__wrap {
        z-index: 3;
        background: $ds-secondary-300;
        // background: #FFFDF0;
        // background-image: url(./assets/img/pacjenci-bank-invicta-min-5.jpg);
        background-size: 1280px;
        background-repeat: no-repeat;
        background-position: center 172px;
      }
      background: transparent;
    }
    .sub-page {
      .v-application__wrap {
        z-index: 3;
        background: $ds-secondary-300;
      }
    }
    .dashboard-page {
      .v-application__wrap {
        z-index: 3;
        background: $ds-background-30;
      }
    }
    .white-page {
      background: white;
    }
    .logo {
      margin-right: 64px;
      width: 300px;
      height: 48px;
    }
    .v-toolbar {
      background: $ds-white !important;
      align-items: flex-end;
      margin: 0 auto;
      width: 1200px;
      .v-toolbar__content {
        display: flex;
        justify-content: space-between;
        max-width: 1200px;
      }
    }
    .view {
      position: relative;
      z-index: 11;
      margin: 0 auto;
      width: 1200px;
      min-height: calc(100vh - 70px);
      background: unset;
      &.coordinator-view {
        width: 960px;
      }
    }
    .nav-link{
      @include nsb-font-button;
      a {
        color: $ds-primary !important;
      }
    }
    .menu_position {
      box-sizing: border-box;
      position: absolute !important;
      margin: 0 !important;
      padding: 0 !important;
      top: calc(-50vh + 64px) !important;
      left: calc(600px - 291px) !important;
      width: 283px;
      min-width: 283px;
      // box-shadow: none !important;
      box-shadow: 0px 5px 10px rgba(0,0,0,0.3) !important;
      border: 1px solid $nsb-color-3 !important;
    }
  }

  .mz-modal {
    .modal-title {
      font-size: 23px !important;
    }
  }

  .clear-button {
    box-sizing: border-box;
    border: 1px solid $ds-primary !important;
    color: $ds-primary !important;
  }
</style>
